import { ICellEditorAngularComp } from 'ag-grid-angular';
import { NgClass } from '@angular/common';
import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ApiService } from '../services/api.service';
import { HttpParams } from '@angular/common/http';
import { ColDef, StatusPanelDef, GridOptions, IMultiFilterParams, GridReadyEvent, IsRowSelectable, IRowNode } from 'ag-grid-community';
import { MessageService } from 'primeng/api';
import { CustomMessageService } from '../services/custom.message.service';


@Component({
  selector: 'inventor-component',
  template: `<p-dialog 
  header="Search and Select Inventors" 
  [visible]="openDialog" [draggable]="false"
  [modal]="true" [closable]="false"
  [style]="{ width: '95%',height: '700px' }" appendTo="body" (onHide)="close()">
  <ng-template pTemplate="header">
          <span style="width:100%"> 
          <div  style="display: flex;justify-content: space-between;">
            <div>
              <label style="font-weight: bold;font-size: 17px;">Select Inventor LeId(s)</label>
            </div>
            <div>
           
              <!-- <button style="width: fit-content; " pButton type="button" [disabled]="!(getInventorCount > 0)" (click)="addLes(false)" style="margin-right: 10px">Add</button> -->
              <button style="width: fit-content; margin-left: 10px;" pButton type="button" [disabled]="!(inventorsPreviewList.length > 0)" (click)="addLes(true)">Update & Close</button>  
              <button style="width: fit-content; margin-left: 10px;margin-right: 3px" pButton type="button" (click)="reset()">Reset</button>              
              <i class="pi pi-times" (click)="close()" style="margin-right: 10px;font-size:18px;"></i>
            </div>
          </div>      
          </span>
        </ng-template>
        <div class="grid">
          <div class="col-5">
            <div style="display: flex;justify-content: flex-start;margin-top: 15px;">       
              <div>
                  <label style="font-weight: bold;font-size: large;vertical-align: middle;"> Search By :</label>
                  <span style="margin-left: 4px">
                  <p-radioButton [style]="{'margin-bottom' : '5px'}" value="Person" [(ngModel)]="searchBy" label="Person" (onClick)="setSearch($event)"/>
                  <p-radioButton value="Organization" label="Organization" [style]="{'margin-left': '5px','margin-bottom' : '5px'}"[(ngModel)]="searchBy"  (onClick)="setSearch($event)"/>
                  </span>
                  <span style="margin-left: 4px">
                  <button style="width: fit-content; " pButton type="button" [disabled]="searchBy == 'Person' ? !(firstName || lastName) : !orgName" (click)="search()" style="margin-right: 10px">Search</button>
                  </span>
                  <!-- <label  style="font-weight: bold; display: block; margin-bottom: 12px;margin-top: 5px;">Total Rows : {{idList.length}}</label> -->
                  <!-- <span>
                  <textarea style="max-height: 244px;" [rows]="10" [cols]="20" [autoResize]="true" [(ngModel)]="idListText" pInputTextarea></textarea>
                  </span> -->
              </div>
            </div>
            <div style="display: flex;column-gap:30px;margin-top: 15px;">
                <div *ngIf="searchBy == 'Person'">
                    <label>First Name: </label>
                    <input type="text"  (keyup.enter)="search()" pInputText [(ngModel)]="firstName"/>
                </div>
                <div *ngIf="searchBy == 'Person'">
                    <label>Last Name: </label>
                    <input type="text"  (keyup.enter)="search()" pInputText [(ngModel)]="lastName"/>
                </div>
                <div *ngIf="searchBy != 'Person'">
                    <label>Organization Name: </label>
                    <input type="text"  (keyup.enter)="search()" pInputText [(ngModel)]="orgName"/>
                </div>
            </div>
            <ag-grid-angular *ngIf="rowData.length > 0" id="agGrid"
              style="height: 50vh; width: 35vw; max-width: 600px;" class="ag-theme-balham" [columnDefs]="columnDefs" 
              [defaultColDef]="defaultColDef" [rowData]="rowData" [isRowSelectable]="isRowSelectable"
              [gridOptions]="gridOptions" [statusBar]="statusBar" (gridReady)="onGridReady($event)" [enableRangeSelection]=true                    
              [rowSelection]="'multiple'" [suppressRowClickSelection]="true" [animateRows]="true"></ag-grid-angular>
          </div>  
          <div class="col-3">
            <span>
              <button style="width: fit-content; " pButton type="button" [disabled]="!(getInventorCount > 0)" (click)="appendToPreview()">Append To Preview</button>
              <button style="width: fit-content; " pButton type="button" [disabled]="!(selectedInventors.length > 0)" (click)="remove()" style="margin-left : 5px">Remove</button>
            </span>        
            <p-listbox [style.visibility]="inventorsPreviewList.length === 0 ? 'hidden' : 'visible'" [options]="inventorsPreviewList" [(ngModel)]="selectedInventors" optionLabel="name" [multiple]="true"  [style]="{'width':'15rem','margin-top': '10px'}" [listStyle]="{'max-height': '220px','width':'15rem'}" />
          </div>
          <div class="col-3">
            <p-card header="No matching records found">
                If inventor not found - could be multiple reasons.
                <ol>
                  <li>1. Person is in CRADLE, but was not migrated so no LE ID is in history table.</li>
                  <li> 2. Person is not in CRADLE. Must create LE ID in PRISM, and migrate to CRADLE via the internal API.</li>
                </ol>
            </p-card>
          </div> 
        </div>
</p-dialog>
`
})
export class InventorLeEditorComponent  implements ICellEditorAngularComp  {
  public params!: any;
  searchBy : string = 'Person';
  firstName : string = "";
  lastName : string = "";
  orgName : string = "";
  openDialog : boolean = true;
  rowData : any[] =[];
  inventorsPreviewList: any[] = [];
  selectedInventors: any[] = [];
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: { buttons: ["clear"] },
    minWidth : 50, 
    resizable: true,
  };
  public columnDefs: any[] = [
    
  ];
  public statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
    statusPanels: [
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
      { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
      { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
      { statusPanel: 'agSelectedRowCountComponent', align : 'left' },
      { statusPanel: 'agAggregationComponent' },
    ],
  };
  gridOptions : GridOptions = {
    context: {
      componentParent: this,
    },
    singleClickEdit: true,
    tooltipShowDelay: 100,
    sideBar: { toolPanels: [{
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    },
    'filters'] },
    // onGridPreDestroyed: this.onGridPreDestroyed
  };
  public isRowSelectable: IsRowSelectable = (
    params: IRowNode<any>,
  ) => {
    return params.data && params.data.leId;
  };
  
  gridApi: any;

  agInit(params: any): void {
    this.params = params;
    this.inventorsPreviewList = this.params.context?.componentParent.inventorsList?.length > 0 && this.params.context?.componentParent.inventorsList?.find((e : any) => e.geId == this.params.data.geId)?.inventors ? this.params.context?.componentParent.inventorsList?.find((e : any) => e.geId == this.params.data.geId)?.inventors : [];
  }

  get getInventorCount() : number {
    return this.gridApi ? this.gridApi?.getSelectedRows()?.length : 0;
  }

  constructor(private apiService: ApiService, private messageService : CustomMessageService) {
    
  }


  getValue(): any {
    return '';
  }
  search() {
    this.columnDefs.splice(0);
    this.rowData.splice(0);
    const url = this.searchBy == "Person" ? 'GetPersonByName' : 'GetOrganizations';
    const nameFilter = this.searchBy == "Person" ? this.firstName + " " + this.lastName : this.orgName;
    let params = new HttpParams();
    params = params.append('namefilter',nameFilter);
    if (this.searchBy == "Person") {
        this.columnDefs.push( 
            { field: '', pinned: 'left', checkboxSelection: true, headerCheckboxSelection : true,headerCheckboxSelectionFilteredOnly: true, lockPosition: "left", suppressHeaderFilterButton: true,resizable: false, width:15 },  
            { field: 'lastName', headerName : 'Last Name', filter: 'agTextColumnFilter', width : 165,  headerTooltip : 'Last Name', },
            { field: 'firstName', headerName : 'First Name', filter: 'agTextColumnFilter',width : 165,headerTooltip : 'First Name' },           
            { field: 'leId', headerName : 'Le ID', filter: 'agTextColumnFilter', width : 165, headerTooltip: 'Le ID' })
    } else {
        this.columnDefs.push( 
            { field: '', pinned: 'left', checkboxSelection: true, headerCheckboxSelection : true,headerCheckboxSelectionFilteredOnly: true, lockPosition: "left", suppressHeaderFilterButton: true,resizable: false, width:15 },  
            { field: 'organizationName', headerName : 'Organization Name', filter: 'agTextColumnFilter', width : 165,  headerTooltip : 'Organization Name' },
            { field: 'leId', headerName : 'Le ID', filter: 'agTextColumnFilter', width : 165, headerTooltip: 'Le ID' })
    }   
    this.apiService.getData(url,params, true).subscribe( (result : any) => {
        const data = this.searchBy == "Person" ? result.persons : result;
        if (data && data.length > 0)
          this.rowData = data;
        else
          this.messageService.showMessage({severity: 'warn', detail:'No data for your search', summary:'Not found'});
    });
  }

  setSearch(event: any) {
    this.rowData.splice(0);
  }

  addLes(isClose: boolean) {
    const index = this.params.context.componentParent.rowData.findIndex((e: any) => e.geId == this.params.data.geId);
    this.params.context.componentParent.rowData[index].inventorLeIds = this.params.data.inventorLeIds = this.inventorsPreviewList.map((e: any) => e.leId).join();
    const inventorIndex = this.params.context.componentParent.inventorsList.findIndex((ele : any) => ele.geId == this.params.data.geId);
    if (inventorIndex > -1) {
      this.params.context.componentParent.inventorsList[inventorIndex].inventors = this.inventorsPreviewList;
    } else {
      this.params.context.componentParent.inventorsList.push({geId : this.params.data.geId, inventors: this.inventorsPreviewList} );
    }
    let counter = 1;
    Object.keys(this.params.context.componentParent.rowData[index]).filter(k => k.startsWith('Inventor')).forEach(k => delete this.params.context.componentParent.rowData[index][k]);
    const idx = this.params.context.componentParent.columnDefs.findIndex((c: any) => c.field === 'inventorLeIds');
    this.inventorsPreviewList.forEach((inventor: any) => {
      let colName = `Inventor${counter}`;
      if (this.params.context.componentParent.columnDefs.findIndex((c: any) => c.field === colName) === -1)
        this.params.context.componentParent.columnDefs.splice(idx + counter, 0, { field: colName, headerName :colName, headerTooltip: colName, editable: false, width : 165 });
      this.params.context.componentParent.rowData[index][colName] = inventor.name;
      //this.params.context.componentParent.addInventorHeaderName(colName);
      counter++;
    }); 

    this.params.context.componentParent.columnDefs.filter((c: any) => c.field.startsWith('Inventor')).forEach((colDef: ColDef) => {
      let undefinedFields = this.params.context.componentParent.rowData.filter((c: any) => c[colDef.field] == undefined);
      if( undefinedFields.length == this.params.context.componentParent.rowData.length || this.params.context.componentParent.rowData.filter((c: any) => c[colDef.field] != "").length == 0) {    
        this.params.context.componentParent.columnDefs.splice(this.params.context.componentParent.columnDefs.findIndex((c: any) => c.field === colDef.field), 1);
      }
    });     

    this.params.context.componentParent.gridApi.setGridOption("columnDefs", this.params.context.componentParent.columnDefs);
    this.messageService.showMessage({severity: 'success', detail:'Added selected inventors successfully', summary:'Added'});
    if (isClose)
      this.close();
  }

  close() {
    this.openDialog = false;
    this.params.api.stopEditing();
  }

  reset(){
    this.searchBy= "Person";
    this.rowData.splice(0);
    this.firstName = this.lastName = this.orgName = "";
    this.inventorsPreviewList = this.params.context?.componentParent.inventorsList?.length > 0 && this.params.context?.componentParent.inventorsList?.find((e : any) => e.geId == this.params.data.geId)?.inventors ? this.params.context?.componentParent.inventorsList?.find((e : any) => e.geId == this.params.data.geId)?.inventors : [];
  }

  appendToPreview() {
    this.gridApi.getSelectedRows().forEach((ele : any) => {
      if (this.inventorsPreviewList?.findIndex(e => ele.leId == e.leId) < 0) {
        this.inventorsPreviewList = [...this.inventorsPreviewList, this.searchBy == 'Person' ? {leId : ele.leId, name : ele.lastName + ", " + ele.firstName} : {leId: ele.leId, name: ele.organizationName}];
      }
    })
  }

  remove() {
    this.inventorsPreviewList = this.inventorsPreviewList.filter((item : any) => !this.selectedInventors.includes(item));
  }


  onGridReady($event: GridReadyEvent<any>) {
    this.gridApi = $event.api;
  }
}